const getPatientHeightIn = ({ patient, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return patient.Vitals[0]
    ? (`${patient.Vitals[0]['Height Ft']} ft ${patient.Vitals[0]['Height In']} in`) : null;
};

export default getPatientHeightIn;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientHeightFtIn.js